import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-holidays',
  templateUrl: './company-holidays.component.html',
  styleUrls: ['./company-holidays.component.css'],
})
export class CompanyHolidaysComponent implements OnInit {
  holidays2026 = [
    { month: 'January', date: '1 Jan', day: 'Thursday', holiday: 'New Year' },
    {
      month: 'January',
      date: '26 Jan',
      day: 'Monday',
      holiday: 'Republic Day',
    },
    { month: 'March', date: '4 Mar', day: 'Wednesday', holiday: 'Holi' },
    {
      month: 'August',
      date: '15 Aug',
      day: 'Saturday',
      holiday: 'Independence Day',
    },
    {
      month: 'August',
      date: '28 Aug',
      day: 'Friday',
      holiday: 'Raksha Bandhan',
    },
    {
      month: 'October',
      date: '2 Oct',
      day: 'Friday',
      holiday: 'Gandhi Jayanti',
    },
    { month: 'October', date: '20 Oct', day: 'Tuesday', holiday: 'Dussehra' },
    { month: 'November', date: '7 Nov', day: 'Saturday', holiday: 'Diwali' },
    { month: 'November', date: '9 Nov', day: 'Monday', holiday: 'Diwali' },
    {
      month: 'November',
      date: '24 Nov',
      day: 'Tuesday',
      holiday: 'Guru Nanak Dev Ji Gurpurab',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
